(function ($, Drupal) {
  Drupal.behaviors.xscroll = {
    attach: function (context, settings) {
      $(document).ready(function() {
        var isMouseDown = false,
          startX;
        $(`article.teaser .tags ul`).mousedown(function(e) {
          e.preventDefault();
          isMouseDown = true;
          startX = e.pageX;
        });
        $(document).mouseup(function() {
          isMouseDown = false;
        });
        $(`article.teaser .tags ul`).mousemove(function(e) {
          if(isMouseDown) {
            $(this).scrollLeft($(this).scrollLeft() + startX - e.pageX);
            startX = e.pageX;
          }
        });
      });

    }
  }
})(jQuery, Drupal);
